import {DataStatus, Pagination} from 'platform/components';

import {useState} from 'react';

import {isNil} from 'ramda';

import {useOnMount} from 'shared/web';

import {useNavigationDataApi} from '../../api/useNavigationDataApi';
import type {RowV5ResponseBody} from '../../types/api/data';

const MAX_ROWS_LIMIT = 1000;
const FIRST_PAGE = 1;

interface ControlledRowControlProps {
  gridCode: string;
  dataQueryId: string;
  onPageChange: (row: RowV5ResponseBody) => Promise<boolean>;
  entityId: string;
  isDisabled?: boolean;
}

export function ControlledRowControl(props: ControlledRowControlProps) {
  const http = useNavigationDataApi(props.gridCode);
  const [rows, setRows] = useState<RowV5ResponseBody[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useOnMount(() => {
    http.getDataByQuery(props.dataQueryId, 0, MAX_ROWS_LIMIT, false, []).then((response) => {
      setRows(response ?? []);
      setIsLoading(false);
    });
  });

  // Derive the current page from the selected entity so the pagination always reflects
  // the row that is actually open. Computing it once on mount left the page stale when
  // the dialog was reopened on a different row without remounting this component.
  const currentPage = rows.find((row) => row.id === props.entityId)?.rowNumber ?? FIRST_PAGE;

  const handlePageChange = async (newPage: number) => {
    const newRow = rows.find((row) => row.rowNumber === newPage);

    if (isNil(newRow)) {
      return;
    }

    await props.onPageChange(newRow);
  };

  if (isLoading) {
    return <DataStatus isLoading></DataStatus>;
  }

  return (
    <Pagination
      isDisabled={props.isDisabled}
      variant="text-only"
      showPrevButton
      showNextButton
      pagesQuantity={rows.length}
      onPageChange={handlePageChange}
      page={currentPage}
    />
  );
}
